/**
 * @generated SignedSource<<b0cdb0ad5c956d5b3c5dae50911cba79>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobEventStackFinished_event$data = {
  readonly detail?: string | null;
  readonly timestamp: any;
  readonly uuid: string;
  readonly " $fragmentType": "JobEventStackFinished_event";
};
export type JobEventStackFinished_event$key = {
  readonly " $data"?: JobEventStackFinished_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobEventStackFinished_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobEventStackFinished_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timestamp",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "detail",
          "storageKey": null
        }
      ],
      "type": "JobEventStackFinished",
      "abstractKey": null
    }
  ],
  "type": "JobEvent",
  "abstractKey": "__isJobEvent"
};

(node as any).hash = "c7df199bf9697ab78121fd5bc8564242";

export default node;
